import { ICheckPublishTermSchema } from '../../../../repositories/billing-tariffs/entities/PublishTerms/CheckPublishTermSchema';
import { ICheckServiceRequest } from '../../../../repositories/billing-tariffs/v3/check-service';
import { ICheckoutInfoState } from '../../../../types/reducers/checkoutInfo';
import { IOfferState, ICoordinates } from '../../../../types/reducers/offer';
import {
  checkJKCategory,
  checkBusinessCenterCategory,
  getJKId,
  getBusinessCenterId,
  isObjectSplits,
} from '../../../../utils/offer';
import { EMoneySource } from '../../../../types/reducers/user';
import { IPublicationTokens } from '../../../../types/reducers/publishTerms';
import { getIsCalltrackingPhoneChanged } from './getIsCalltrackingPhoneChanged';

interface IGetCheckServiceParams {
  offer: IOfferState;
  locationPath: Array<number>;
  checkoutInfo: ICheckoutInfoState;
  terms: Array<ICheckPublishTermSchema>;
  isServiceChanged: boolean;
  photosCount: number;
  coordinates: ICoordinates;
  extraData: object;
  moneySource: EMoneySource | null;
  publicationTokens: IPublicationTokens;
}

export function getCheckServiceParams(params: IGetCheckServiceParams): ICheckServiceRequest {
  const {
    offer,
    locationPath,
    checkoutInfo,
    terms,
    isServiceChanged,
    photosCount,
    coordinates,
    extraData,
    moneySource,
    publicationTokens,
  } = params;

  const { id: objectId, category } = offer;

  const {
    autoProlongInfo: { isChecked: autoProlong },
  } = checkoutInfo;

  const isJKCategory = checkJKCategory(offer);
  const isBusinessCenterCategory = checkBusinessCenterCategory(offer);
  const newObjectId = getJKId(offer);
  const businessShoppingCenterId = getBusinessCenterId(offer);
  const isMultiListing = isObjectSplits(offer);
  const userHasChangedCalltrackingPhone = getIsCalltrackingPhoneChanged(offer);

  return {
    ...(isJKCategory && { newObjectId }),
    ...(isBusinessCenterCategory && { businessShoppingCenterId }),
    ...(objectId && { objectId }),
    ...(category && { category }),
    locationPath: [...locationPath].reverse().join(','),
    autoProlong,
    terms,
    latitude: coordinates.lat,
    longitude: coordinates.lng,
    isMultiListing,
    userHasChangedServices: isServiceChanged,
    userHasChangedCalltrackingPhone,
    photosCount,
    sourceType: 'website',
    moneySource,
    extraData,
    uiType: 'webview',
    publication: publicationTokens,
  };
}
